import type { ProfileProgress } from "../progression/levels";
import type { OrbitForgeSave, PaidSupplyCrateId } from "../save/types";
import { getPaidSupplyCrateDefinition } from "./catalog";

export function calculatePaidSupplyCratePrice(crateId: PaidSupplyCrateId, save: OrbitForgeSave, progress: ProfileProgress): number {
  const definition = getPaidSupplyCrateDefinition(crateId);
  const opened = save.stats.SupplyCratesOpened;
  const prestige = progress.prestigeLevel > 0;
  const openRamp = 1 + Math.min(prestige ? 1.05 : 0.32, opened * (prestige ? 0.0065 : 0.0045));
  const levelAnchor = levelCreditAnchor(Math.max(2, progress.effectiveLevel));
  let base = Math.max(definition.basePrice, levelAnchor * definition.levelPriceShare);

  if (prestige) {
    const wealth = Math.max(save.stats.TotalEarnedCredits, save.stats.Credits);
    const prestigeFactor = 1 + Math.min(0.6, (progress.prestigeLevel - 1) * 0.015);
    base = Math.max(base, wealth * definition.prestigeWealthShare * prestigeFactor);
  }

  return roundCratePrice(base * openRamp);
}

export function calculateFreeSupplyDropValue(save: OrbitForgeSave, progress: ProfileProgress): number {
  return Math.max(120, calculatePaidSupplyCratePrice("mini", save, progress));
}

export function roundCratePrice(value: number): number {
  return Math.ceil(value);
}

function levelCreditAnchor(level: number): number {
  const estimated = estimatedEarnedCreditsForLevel(level);
  const next = level >= 40 ? estimated * 1.55 : estimatedEarnedCreditsForLevel(level + 1);
  return Math.sqrt(Math.max(1, estimated) * Math.max(estimated, next)) * 0.19;
}

function estimatedEarnedCreditsForLevel(level: number): number {
  return (xpForLevelEstimate(level) / 8.35) ** 2.3255813953488373;
}

function xpForLevelEstimate(level: number): number {
  const n = Math.max(0, level - 1);
  return n ** 2 * 430 + n ** 3 * 27.5;
}
